import { Domains, Languages } from '../../common/v2/constants';

// This is a temporary function
export const getAttritionTranslationKey = (
  domain: Domains,
  selectedLanguage: Languages,
  baseKey: string
) => {
  const splitBaseKey = baseKey.split('.');
  const newSplitKey =
    domain === Domains.NIKKI && selectedLanguage === Languages.EN
      ? [...splitBaseKey.front(), 'nikki', splitBaseKey.last() as string]
      : splitBaseKey;
  return newSplitKey.join('.');
};
